import { takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  FormArray,
  Validators,
} from '@angular/forms';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { v4 as uuidV4 } from 'uuid';

@Component({
  selector: 'app-operation-cadrage-risques-form',
  templateUrl: './operation-cadrage-risques-form.component.html',
  styleUrls: ['./operation-cadrage-risques-form.component.scss'],
})
export class OperationCadrageRisquesFormComponent implements OnInit, OnDestroy {
  subscribe = new Subject();
  isAdd: boolean = true;
  isUpdate: boolean = false;
  today: Date = new Date(Date.now());

  @Input() updateItem$ = new BehaviorSubject<any>(null);
  @Output() add = new EventEmitter<any>(false);
  @Output() update = new EventEmitter<any>(false);
  @Output() cancel = new EventEmitter<boolean>(false);
  types: string[] = [
    'Risque politique',
    'Risque marché',
    'Risque fournisseurs',
    'Risque environnement',
    'Risque client',
    'Management du projet',
    'Autre',
  ];
  itemform: UntypedFormGroup = this.fb.group({});
  title: UntypedFormControl = new UntypedFormControl('', Validators.required);
  type: UntypedFormControl = new UntypedFormControl('', Validators.required);
  description: UntypedFormControl = new UntypedFormControl('');
  id: UntypedFormControl = new UntypedFormControl(uuidV4(), Validators.required);

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.formCreate();
    this.formSet();
  }

  ngOnDestroy(): void {
    this.subscribe.next(null);
    this.subscribe.complete();
  }

  formCreate(): void {
    this.itemform = this.fb.group({
      id: this.id,
      title: this.title,
      type: this.type,
      description: this.description,
    });
  }

  formSet(): void {
    this.updateItem$.pipe(takeUntil(this.subscribe)).subscribe((val): void => {
      if (!val) {
        this.isAdd = true;
        this.isUpdate = false;
        return;
      }
      if (val) {
        this.updateForm(val);
      }
    });
  }

  updateForm(val: any): void {
    this.itemform.patchValue({
      id: val?.id,
      title: val?.title,
      type: val?.type,
      description: val?.description,
    });
    this.isAdd = false;
    this.isUpdate = true;
  }

  onAdd(): void {
    const form = this.itemform.value;
    this.add.emit(form);
    this.itemform.reset();
  }

  onUpdate(): void {
    const form = this.itemform.value;
    this.update.emit(form);
    this.itemform.reset();
  }

  onCancel(): void {
    this.cancel.emit(true);
  }
}
